import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";

function Layout() {
  return (
    <div className="flex w-[100%] h-[100%]">
      <Header />
      <div className="p-4 w-[100%]">
        <Outlet />
      </div>
    </div>
  );
}

export default Layout;
